import React, { useState } from "react";
import { DropdownCrossIcon, FileIcon, UploadIcon } from "../Icons";

const InputFile = ({
  name,
  id,
  onChange,
  supportingDocument,
  onClear,
  text,
  placeholder,
  error,
}) => {
  const [file, setFile] = useState(supportingDocument);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
    if (onChange) {
      onChange(e);
    }
  };

  const clearFile = () => {
    setFile(null);
    document.getElementById(id).value = null;
    if (onClear) {
      onClear();
    }
  };

  return (
    <div
      className={`relative w-full px-3 py-2 rounded-xl border ${
        file ? "border-gray-500" : "border-divider"
      } ${
        error
          ? "border-error-500 bg-error-500/10 focus-within:border-error-500 focus-within:bg-error-500/10"
          : "bg-background-surface focus-within:border-primary-600"
      } shadow-sm single-upload-wrapper`}
    >
      <div
        className={`flex items-center w-full ${
          file
            ? "bg-background-secondary rounded-lg px-2 py-2 h-10"
            : "bg-transparent"
        }`}
      >
        <div className="flex-shrink-0">
          {file ? <FileIcon /> : <UploadIcon />}
        </div>
        <label
          htmlFor={id}
          className={`line-clamp-1 w-full items-center justify-between pl-2 text-xs font-medium text-primary-600 cursor-pointer 

          `}
        >
          {file ? file.name : text}
        </label>
      </div>
      {!file && (
        <p className="font-normal flex items-center ml-7 mt-1 text-xs text-text-secondary">
          {placeholder}
        </p>
      )}
      <input
        type="file"
        name={name}
        id={id}
        onChange={handleFileChange}
        className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
        title=""
      />
      {file && (
        <div
          className="absolute inset-y-0 right-0 flex items-center pr-4 cursor-pointer"
          onClick={clearFile}
        >
          <DropdownCrossIcon />
        </div>
      )}
      {error && <span className="text-error-500 text-sm">{error}</span>}
    </div>
  );
};

export default InputFile;
